export default {
      id: "ic-fil-tv-light-grey-usage",
      viewBox: "0 0 19 18",
      url: "/" + "images/icons.3.109.2.svg#ic-fil-tv-light-grey-usage",
      toString: function () {
        return this.url;
      }
    }